import type { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types';
import { type RecommendationExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export type { ProvisioningPageExtensionsOptions } from './types';

export const recommendationContextExtensionsWhitelist: string[] = ['recommendationContext'];

export const createRecommendationContextExtensions = (
	options: RecommendationExtensionsOptions,
): CrossFlowExtensions =>
	createProductExtensions<{
		recommendationContext: RecommendationExtensionsOptions;
	}>(recommendationContextExtensionsWhitelist)({
		recommendationContext: options,
	});
